import React from 'react';
import './Navbar.css';
// import './jquery.mobile.css';
import Banner from './Banner/Banner.js';

const Navbar = ({ onFilterChange }) => {
    return (
        <div style={{ position: 'relative' }}>
            <Banner />
        </div>
    );
};

export default Navbar;
